import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '@environments/environment';
import * as fromLogin from '@login/ngrx/login.reducer';
import * as fromRouter from '@ngrx/router-store';
import * as fromMain from '@main/ngrx/reducers/main.reducer';
import * as fromAssociations from '@clients/ngrx/reducers/associations.reducer';
import * as fromAdministrators from '@references/ngrx/reducers/administrators.reducer';
import * as fromRoles from '@references/ngrx/reducers/roles.reducer';
import * as fromKatottg from '@references/ngrx/reducers/katottg.reducer';
import * as fromErdpou from '@references/ngrx/reducers/erdpou.reducer';
import * as fromUsers from '@clients/ngrx/reducers/users.reducer';
import * as fromRequests from '@support/ngrx/reducers/requests.reducer';
import * as fromContacts from '@crm/ngrx/reducers/contacts.reducer';
import * as fromCrmSettings from '@crm/ngrx/reducers/settings.reducer';
import * as fromLeadsBoard from '@crm/ngrx/reducers/leads-board.reducer';
import * as fromLeadsList from '@crm/ngrx/reducers/leads-list.reducer';
import * as fromProjects from '@crm/ngrx/reducers/projects.reducer';
import * as versionHistoryReducer from '@references/ngrx/reducers/version-history.reducer';
import * as accountantMonitorReducer from '@crm/ngrx/reducers/accountant-monitor.reducer';
import * as contractsReducer from '@billing/ngrx/reducers/contracts.reducer';
import * as counterpartyReducer from '@billing/ngrx/reducers/counterparty.reducer';
import * as paymentsReducer from '@billing/ngrx/reducers/payments.reducer';
import * as actsReducer from '@billing/ngrx/reducers/acts.reducer';
import * as invoicesReducer from '@billing/ngrx/reducers/invoices.reducer';
import * as supportServiceReducer from '@support/ngrx/reducers/support-service.reducer';
import * as knowledgeBaseReducer from '@support/ngrx/reducers/knowledge-base.reducer';

export interface Reducers {
  router: fromRouter.RouterReducerState;
  login: fromLogin.State;
  main: fromMain.State;
  associations: fromAssociations.State;
  administrators: fromAdministrators.State;
  roles: fromRoles.State;
  katottg: fromKatottg.State;
  erdpou: fromErdpou.State;
  users: fromUsers.State;
  requests: fromRequests.State;
  contacts: fromContacts.State;
  crmSettings: fromCrmSettings.State;
  leadsBoard: fromLeadsBoard.State;
  leadsList: fromLeadsList.State;
  projects: fromProjects.State;
  versionHistory: versionHistoryReducer.State;
  accountantMonitor: accountantMonitorReducer.State;
  contracts: contractsReducer.State,
  counterparty: counterpartyReducer.State,
  payments: paymentsReducer.State
  acts: actsReducer.State,
  invoices: invoicesReducer.State,
  supportService: supportServiceReducer.State,
  knowledgeBase: knowledgeBaseReducer.State,
}

export const reducers: ActionReducerMap<Reducers, any> = {
  router: fromRouter.routerReducer,
  login: fromLogin.reducer,
  main: fromMain.reducer,
  associations: fromAssociations.reducer,
  administrators: fromAdministrators.reducer,
  roles: fromRoles.reducer,
  katottg: fromKatottg.reducer,
  erdpou: fromErdpou.reducer,
  users: fromUsers.reducer,
  requests: fromRequests.reducer,
  contacts: fromContacts.reducer,
  crmSettings: fromCrmSettings.reducer,
  leadsBoard: fromLeadsBoard.reducer,
  leadsList: fromLeadsList.reducer,
  projects: fromProjects.reducer,
  versionHistory: versionHistoryReducer.reducer,
  accountantMonitor: accountantMonitorReducer.reducer,
  contracts: contractsReducer.reducer,
  counterparty: counterpartyReducer.reducer,
  payments: paymentsReducer.reducer,
  acts: actsReducer.reducer,
  invoices: invoicesReducer.reducer,
  supportService: supportServiceReducer.reducer,
  knowledgeBase: knowledgeBaseReducer.reducer,
};

export const metaReducers: MetaReducer<Reducers>[] = !environment.production ? [] : [];
